<template>
  <form ref="uploadForm">
    <input @change="_onSelected"
           data-test-path="upload-file-input"
           type="file"
           ref="fileInput"
           class="p-0 m-0"
           accept="image/jpeg, image/png"
           multiple
           style="display:block; width: 0px; height: 0px; overflow: hidden;"/>
    <b-container class="p-0 justify-content-center">
      <b-col>
        <b-button :disabled="readOnly" class="mr-1 w-100 custom-button" type="button"
                  @click="_triggerFileSelection">
          <font-awesome-icon icon="file-upload"/>
          <label class="m-0" style="font-size: 0.9rem;">{{
              $tr("upload-image-button", "Upload Your Image")
            }}</label>
        </b-button>
      </b-col>
    </b-container>
  </form>
</template>

<script>
export default {
  name: "FileUploadButton",
  methods: {
    setError(err) {
      console.error(err);
      this.reset();
    },

    reset() {
      this.files = [];
      this.fileName = "";
      this.$refs.uploadForm.reset();
    },

    getFiles() {
      return this.files;
    },

    getFileName() {
      return this.fileName;
    },

    _triggerFileSelection() {
      this.reset();
      this.$refs.fileInput.click();
    },

    _onSelected() {
      if (!this.$refs.fileInput.files || this.$refs.fileInput.files.length === 0) {
        this.reset();
        return;
      }
      const files = Array.from(this.$refs.fileInput.files);
      this.fileName = files.map(file => file.name).join(", ");
      const maxFileSize = 250 * 1024 * 1024; // 250 MB

      const forbiddenCharacters = /[\\/:*?"<>||]/;
      const forbiddenCharactersDisplay = "\\ / : * ? \" < > | ";
      const message = $tr("illegal.characters.file.name.error.upload", "The file name contains illegal characters. Illegal characters: ");
      const finalMessage = message + forbiddenCharactersDisplay;

      const validTypes = ['image/jpeg', 'image/png'];
      for (let file of files) {
        if (forbiddenCharacters.test(file.name)) {
          this.setError(finalMessage);
          return;
        }
        if (file.size > maxFileSize) {
          this.setError($tr("maximum.file.size.error", "File exceeds maximum size of 250 MB."));
          return;
        }
        if (!validTypes.includes(file.type)) {
          this.setError($tr("invalid.file.type.error", "Only JPG and PNG files are allowed."));
          return;
        }
      }
      this.files = files;
      this.$emit("file-selected", this.files);
    }
  },
  props: {
    fileSelected: Function,
    readOnly: { type: Boolean, default: false },
    allowNewUpload: { type: Boolean, default: true }
  },
  data() {
    return {
      fileName: "",
      files: [],
    }
  }
}
</script>

<style scoped>
.custom-button {
  color: #4D7A98;
  font-weight: bold;
  background-color: transparent;
  border-radius: 5px;
  border: 2px solid #4D7A98;
}

.custom-button:hover {
  color: #FFFFFF;
  background-color: #4D7A98;
}
</style>
